import React from 'react'

import FeaturesHero from 'components/shared/FeaturesHero'
import SliceManager from 'components/shared/SliceManager'
import PreviewBanner from 'components/shared/PreviewBanner'

import { getDataDependencies } from 'services/api'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'

const Features = ({ pageData: { slices, featuresHero }, preview }) => {
  return (
    <>
      {preview && <PreviewBanner />}
      {featuresHero && <FeaturesHero {...featuresHero} />}
      {slices && <SliceManager slices={slices} />}
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const data = await fetchSingleType('feature', preview)

  const extendedData = await getDataDependencies(data)

  return { props: { pageData: extendedData, preview } }
}

export default Features
